/**
 * TanStack Query hooks for `igaming-deposit-stream`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingDepositStreamQueryKeys,
	type CreateIgamingDepositStreamBody,
	type ListIgamingDepositStreamResponse,
	type IgamingDepositStreamRow,
} from "./api";

export function useIgamingDepositStreamList(): UseQueryResult<ListIgamingDepositStreamResponse, Error> {
	return useQuery({
		queryKey: igamingDepositStreamQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingDepositStreamCreate(): UseMutationResult<IgamingDepositStreamRow, Error, CreateIgamingDepositStreamBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositStreamQueryKeys.all });
		},
	});
}

export function useIgamingDepositStreamDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositStreamQueryKeys.all });
		},
	});
}
